module.exports = __webpack_public_path__ + "static/media/am.ee6a9645.svg";